<template>
    <v-container grid-list-md fluid>
        <template v-if="isAuthorized">
            <v-row
                no-gutters
                :class="
                    displayScenariosSelection && budgetId
                        ? 'd-flex align-center pt-2 px-1 pb-4'
                        : 'd-flex align-center px-1'
                "
                id="Date"
                v-if="
                    emit ||
                    (displayScenariosSelection && !$vuetify.display.mobile) ||
                    !selectedAccountingPeriod
                "
            >
                <v-col
                    cols="1"
                    v-if="emit"
                    class="d-flex align-center justify-center"
                    data-cy="Dashboard-back"
                >
                    <v-btn-back @click.stop="emit = null" />
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '10' : '2'"
                    :class="$vuetify.display.mobile ? 'pl-2' : ''"
                    v-if="
                        !(emit === 'tresorerie' && displayScenariosSelection && budgetId) &&
                        !selectedAccountingPeriod
                    "
                >
                    <oss-date-picker
                        :hideDetails="true"
                        v-model="start"
                        type="month"
                        format="MMMM YYYY"
                        prefixDataCy="Dashboard-month"
                    />
                    <!-- <month-picker :range="!!emit" :hideDetails="true" v-model="start" /> -->
                </v-col>
                <!-- <v-col
                    :cols="$vuetify.display.mobile ? '10' : '2'"
                    :class="$vuetify.display.mobile ? 'pl-2' : ''"
                    v-if="
                        !(emit === 'tresorerie' && displayScenariosSelection && budgetId) &&
                        emit &&
                        !selectedAccountingPeriod
                    "
                >
                    <oss-date-picker
                        multiple="range"
                        :hideDetails="true"
                        v-model="start"
                        type="month"
                        format="MMMM YYYY"
                        :filterWithSelectedAccountingPeriod="true"
                    />
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '11' : '2'"
                    :class="$vuetify.display.mobile ? 'pl-2' : ''"
                    v-if="
                        !(emit === 'tresorerie' && displayScenariosSelection && budgetId) &&
                        !emit &&
                        !selectedAccountingPeriod
                    "
                >
                    <oss-date-picker
                        :hideDetails="true"
                        v-model="start"
                        type="month"
                        format="MMMM YYYY"
                        :filterWithSelectedAccountingPeriod="true"
                        prefixDataCy="Dashboard-month"
                    />
                </v-col> -->
                <v-col
                    cols="2"
                    v-if="emit === 'tresorerie' && !$vuetify.display.mobile && isAllowedToDashboard"
                >
                    <v-select
                        outlined
                        v-model="displayCashFlowChart"
                        :items="cashChartsDisplayOptions"
                        item-value="id"
                        single-line
                        required
                        :class="displayScenariosSelection && budgetId ? '' : 'ml-4'"
                        hide-details
                        @update:model-value="onDisplayCashFlowChartChanged()"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
                <v-col cols="2" v-if="displayScenariosSelection && !$vuetify.display.mobile">
                    <v-select
                        outlined
                        v-model="budgetId"
                        :items="scenarios"
                        item-value="id"
                        single-line
                        required
                        class="ml-4"
                        hide-details
                        @update:model-value="queryBudgetForecastFromBudget"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
                <v-col
                    cols="2"
                    v-if="displayScenariosSelection && budgetId && !$vuetify.display.mobile"
                >
                    <v-select
                        outlined
                        v-model="selectedPeriod"
                        :items="periodsList"
                        item-value="id"
                        single-line
                        required
                        class="ml-4"
                        hide-details
                        @update:model-value="queryBudgetForecastFromPeriods"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
                <v-col
                    :cols="displayScenariosSelection ? '5' : '8'"
                    class="d-flex align-self-start"
                    v-if="
                        !$vuetify.display.mobile &&
                        emit !== 'tresorerie' &&
                        !selectedAccountingPeriod
                    "
                >
                    <v-radio-group
                        v-model="unitOfTime"
                        inline
                        data-cy="dashboard-unitOfTime"
                        class="d-flex align-center"
                        color="primary"
                    >
                        <v-radio
                            label="Jour"
                            value="day"
                            data-cy="dashboard-unitOfTime-day"
                            class="d-flex align-center"
                        />
                        <v-radio
                            label="Semaine"
                            value="week"
                            data-cy="dashboard-unitOfTime-week"
                            class="d-flex align-center"
                        />
                        <v-radio
                            label="Mois"
                            value="month"
                            data-cy="dashboard-unitOfTime-month"
                            class="d-flex align-center"
                        />
                    </v-radio-group>
                </v-col>
                <v-col class="d-flex justify-end" v-if="!$vuetify.display.mobile">
                    <TutorialButtonDialog :starterComponents="'Dashboard;'"> </TutorialButtonDialog>
                    <!-- <v-btn-icon
                        icon="$oss-help"
                        @click="startTuto()"
                        v-if="$vuetify.display.smAndUp"
                        size
                    >
                    </v-btn-icon> -->
                    <!-- Commented for now, evolution incoming with Product Fruitz -->
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-if="
                    !(displayScenariosSelection && budgetId) &&
                    dateTicksLabels &&
                    dateTicksLabelCount
                "
            >
                <v-col cols="12">
                    <v-range-slider
                        v-model="dateRange"
                        min="0"
                        :max="dateTicksLabelCount - 1"
                        data-cy="dashboard-slider"
                        :ticks="dateTicksLabels"
                    />
                </v-col>
                <!-- <v-col cols="12">
                    {{ startDate +" " + endDate }}
                </v-col> -->
            </v-row>
            <!-- <v-row no-gutters v-if="emit">
                <v-col class="ma-0 mb-4">
                    <v-btn  rounded size="small" elevation="0" @click="emit = null">
                        <v-icon>arrow_back_ios</v-icon> Retour
                    </v-btn>
                </v-col>
            </v-row> -->
            <v-row no-gutters v-show="!emit">
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-if="enableBank"
                >
                    <CardBank
                        v-model="areBalancesReconciled"
                        :companyId="companyId"
                        @onVueDetailedChanged="
                            () => {
                                emit = 'tresorerie';
                            }
                        "
                        id="TreasuryDashboard"
                    />
                </v-col>
                <template v-for="(card, index) in personalisedCards">
                    <template v-if="isCardAmount(card)">
                        <v-col
                            :cols="$vuetify.display.mobile ? '12' : '4'"
                            :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                            :key="index"
                        >
                            <CardAmount
                                :companyId="companyId"
                                :periods="periods"
                                :indicator="card"
                                :showBtnDetails="true"
                                @onVueDetailedChanged="onVueDetailedChanged(card)"
                                @deleteTheCard="refresh()"
                            >
                            </CardAmount>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col
                            :cols="$vuetify.display.mobile ? '12' : '4'"
                            :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                            :key="index"
                        >
                            <CardRatio
                                :companyId="companyId"
                                :periods="periods"
                                :indicator="card"
                                :showBtnDetails="false"
                                @onVueDetailedChanged="onVueDetailedChanged(card)"
                                @deleteTheCard="refresh()"
                            />
                        </v-col>
                    </template>
                </template>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-show="checkInvoiceOrSale411Display"
                >
                    <CardBalance
                        :companyId="companyId"
                        :accountableAccounts="['411']"
                        @display="checkInvoiceOrSale411Display = $event"
                    >
                    </CardBalance>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-show="checkInvoiceOrSale401Display"
                >
                    <CardBalance
                        :companyId="companyId"
                        :accountableAccounts="['401']"
                        @display="checkInvoiceOrSale401Display = $event"
                    >
                    </CardBalance>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-show="checkInvoiceOrSale421Display"
                >
                    <CardBalance
                        :companyId="companyId"
                        :accountableAccounts="['421']"
                        @display="checkInvoiceOrSale421Display = $event"
                    >
                    </CardBalance>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-show="checkInvoiceOrSale455Display"
                >
                    <CardBalance
                        :companyId="companyId"
                        :accountableAccounts="['455']"
                        @display="checkInvoiceOrSale455Display = $event"
                    >
                    </CardBalance>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-show="checkInvoiceOrSale4670Display"
                    v-if="!isIncomingOutgoingPayment"
                >
                    <CardBalance
                        :companyId="companyId"
                        :accountableAccounts="['467']"
                        @display="checkInvoiceOrSale4670Display = $event"
                    >
                    </CardBalance>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-show="checkInvoiceOrSale4671Display"
                >
                    <CardBalance
                        :companyId="companyId"
                        :accountableAccounts="['425']"
                        @display="checkInvoiceOrSale4671Display = $event"
                    >
                    </CardBalance>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-show="checkInvoiceOrSale511And531Display"
                >
                    <CardBalance
                        :companyId="companyId"
                        :accountableAccounts="['511', '531']"
                        @display="checkInvoiceOrSale511And531Display = $event"
                    />
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '4'"
                    :class="$vuetify.display.mobile ? 'py-2' : 'pa-2'"
                    v-for="ext of extensionsCard"
                    :key="ext.id"
                >
                    <v-card
                        elevation="0"
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                                : 'default_card dashboard_card d-flex flex-column ma-0'
                        "
                        :style="$vuetify.display.mobile ? 'height: 100%' : 'height: 250px'"
                    >
                        <v-card-title>
                            <v-row no-gutters style="flex-wrap: nowrap">
                                <v-col class="d-flex flex-grow-1" style="height: fit-content">
                                    {{ ext.name }}
                                </v-col>
                                <v-col class="d-flex flex-shrink-1 flex-grow-0">
                                    <v-btn-icon
                                        icon="$fa-search-plus"
                                        @click="ext.dialogStatus = !ext.dialogStatus"
                                        size="small"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <oss-widget-embedder v-bind="ext" v-model:dialogStatus="ext.dialogStatus" />
                    </v-card>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : '4'" class="pa-2">
                    <v-hover v-slot="{ isHovering, props }">
                        <v-card
                            v-bind="props"
                            :elevation="isHovering ? '4' : '0'"
                            :class="
                                $vuetify.display.mobile
                                    ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                                    : 'default_card dashboard_card d-flex flex-column ma-0'
                            "
                            :style="$vuetify.display.mobile ? 'height: 120px' : 'height: 250px'"
                            @click="chooseAccountableKey = true"
                        >
                            <v-row
                                no-gutters
                                class="fill-height"
                                id="AddIndicatorDashboard"
                                data-cy="dashboard-addIndicator"
                            >
                                <v-col
                                    cols="12"
                                    class="title mx-2 my-2"
                                    style="height: fit-content"
                                >
                                    Ajouter un indicateur
                                </v-col>
                                <v-col
                                    cols="12"
                                    class="d-flex justify-center align-center"
                                    style="height: fit-content"
                                >
                                    <v-btn-add-icon
                                        data-cy="dashboard-new-indicator-btn"
                                        size="small"
                                    >
                                    </v-btn-add-icon>
                                    <!-- <VBtn-filled
                                        variant="plain"
                                        data-cy="dashboard-new-indicator-btn"
                                        size="x-large"
                                        fab
                                        icon="$add"
                                    >
                                    </VBtn-filled> -->
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-hover>
                </v-col>
            </v-row>
            <v-row v-if="emit === 'sales'">
                <v-col cols="12">
                    <BarChartCardSales
                        v-if="!(displayScenariosSelection && budgetId)"
                        :startDate="startDate"
                        :endDate="endDate"
                        :unitOfTime="unitOfTime"
                        :activeBack="false"
                    >
                    </BarChartCardSales>
                    <BarChartCard
                        v-if="displayScenariosSelection && budgetId"
                        :title="$t('shared.salesForecastVersusActual')"
                        :legend="true"
                        :loading="forecastBudgetWithActualLoading"
                        :data="salesForecastVersusActualData"
                        :activeBack="false"
                        :selectedPeriod="selectedPeriod"
                        :md6="false"
                        :midHeight="true"
                        :showYearNMinus1="true"
                        :yearNMinus1="true"
                        :selectedTags="[]"
                    >
                    </BarChartCard>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '5'"
                    v-if="
                        statsPartitionTag &&
                        (!$vuetify.display.mobile || selectedPartitionTag) &&
                        isAllowedToDashboard
                    "
                >
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0 fill-height'
                                : 'default_card dashboard_card elevation-0 ma-0 fill-height'
                        "
                    >
                        <v-card-title primary-title class="d-flex align-center">
                            <v-row no-gutters>
                                <v-col>
                                    {{ $t("dashboard.sales_allocation") }}
                                </v-col>
                                <v-col
                                    class="pl-2"
                                    v-if="partitionTags.length && isAllowedToDashboard"
                                >
                                    <v-select
                                        v-model="selectedPartitionTag"
                                        :items="partitionTags"
                                        item-value="id"
                                        hide-details
                                        class="mt-0 mb-0 pt-0 pb-0"
                                        data-cy="Dashboard-selectedPartitionTag"
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    >
                                        <template v-slot:selection="{ item }">
                                            <v-chip label size="small">
                                                <span>{{ item.title }}</span>
                                            </v-chip>
                                        </template>
                                    </v-select>
                                </v-col>
                                <template v-if="isAllowedToDashboard">
                                    <template v-for="(tag, index) in selectedPath">
                                        <v-col
                                            class="pl-2"
                                            v-if="tag.tags && tag.tags.length"
                                            :key="index"
                                        >
                                            <v-select
                                                v-model="tag.selected"
                                                :items="tag.tags"
                                                return-object
                                                hide-details
                                                class="pl-2"
                                                v-if="tag.tags && tag.tags.length"
                                                density="compact"
                                                :item-title="(item) => item.name"
                                            >
                                                <template v-slot:selection="{ item }">
                                                    <v-chip label size="small">
                                                        <span>{{ item.title }}</span>
                                                    </v-chip>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </template>
                                </template>
                            </v-row>
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <template v-if="statsPartitionTagLoading && isAllowedToDashboard">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                    style="margin: 24px"
                                />
                            </template>
                            <pie-chart
                                v-else-if="statsPartitionTag && isAllowedToDashboard"
                                :data="statsPartitionTag"
                                :options="{
                                    plugins: {
                                        legend: {
                                            display: selectedPartitionTag ? true : false,
                                            position: 'bottom',
                                        },
                                    },
                                    maintainAspectRatio: false,
                                    ticks: { min: 0 },
                                }"
                                :height="$vuetify.display.mobile ? 200 : 300"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : '6'" v-if="statsCustomers">
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        "
                    >
                        <v-card-title primary-title>
                            <span>Revenus par client</span>
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <template v-if="statsCustomersLoading">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                    style="margin: 24px"
                                />
                            </template>
                            <bar-chart
                                v-else-if="statsCustomers"
                                :data="statsCustomers"
                                :options="statsCustomersOptions"
                                :height="$vuetify.display.mobile ? 200 : 350"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : '6'" v-if="statsProducts">
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        "
                    >
                        <v-card-title primary-title>
                            <span>Revenus par produit</span>
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <template v-if="statsProductsLoading">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                    style="margin: 24px"
                                />
                            </template>
                            <bar-chart
                                v-else-if="statsProducts"
                                :data="statsProducts"
                                :options="statsCustomersOptions"
                                :height="$vuetify.display.mobile ? 200 : 350"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-else-if="emit === 'costs'">
                <v-col cols="12">
                    <BarChartCardPurchase
                        v-if="!(displayScenariosSelection && budgetId)"
                        :startDate="startDate"
                        :endDate="endDate"
                        :unitOfTime="unitOfTime"
                        :activeBack="false"
                    >
                    </BarChartCardPurchase>
                    <BarChartCard
                        v-if="displayScenariosSelection && budgetId"
                        :title="$t('shared.purchaseForecastVersusActual')"
                        :legend="true"
                        :loading="forecastBudgetWithActualLoading"
                        :data="purchaseForecastVersusActualData"
                        :activeBack="false"
                        :selectedPeriod="selectedPeriod"
                        :md6="false"
                        :midHeight="true"
                        :showYearNMinus1="true"
                        :yearNMinus1="false"
                        :selectedTags="[]"
                    >
                    </BarChartCard>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '6'"
                    v-if="
                        partitionTags &&
                        (!$vuetify.display.mobile || selectedPartitionTag) &&
                        isAllowedToDashboard
                    "
                >
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0 fill-height'
                                : 'default_card dashboard_card elevation-0 ma-0 fill-height'
                        "
                    >
                        <v-card-title primary-title class="d-flex align-center">
                            <!-- <div class="ml-0 mt-0 mb-0 pt-0 pb-0">{{ $t('dashboard.expenses_allocation') }}</div>
                            <v-spacer v-if="!selectedPath || selectedPath.length || !selectedPath[0].tags.length"></v-spacer> -->
                            <v-row no-gutters>
                                <v-col>
                                    {{ $t("dashboard.expenses_allocation") }}
                                </v-col>
                                <v-col class="pl-2">
                                    <v-select
                                        v-model="selectedPartitionTag"
                                        :items="partitionTags"
                                        item-value="id"
                                        class="mt-0 mb-0 pt-0 pb-0"
                                        hide-details
                                        v-if="partitionTags.length && isAllowedToDashboard"
                                        density="compact"
                                        :item-title="(item) => item.name"
                                    >
                                        <template v-slot:selection="{ item }">
                                            <v-chip label size="small">
                                                <span>{{ item.title }}</span>
                                            </v-chip>
                                        </template>
                                    </v-select>
                                </v-col>
                                <template
                                    v-if="
                                        root &&
                                        root.tags &&
                                        root.tags.length &&
                                        isAllowedToDashboard
                                    "
                                >
                                    <v-col
                                        :class="index === 0 ? 'pl-2' : ''"
                                        v-for="(tag, index) in selectedPath"
                                        :key="index"
                                    >
                                        <v-select
                                            v-model="tag.selected"
                                            :items="tag.tags"
                                            return-object
                                            hide-details
                                            class="mt-0 mb-0 pt-0 pb-0"
                                            @click:append-outer="removeSelectedPath(index)"
                                            density="compact"
                                            item-title="name"
                                            append-inner-icon="$clear"
                                        >
                                            <template v-slot:selection="{ item }">
                                                <v-chip label size="small">
                                                    <span>{{ item.title }}</span>
                                                </v-chip>
                                            </template>
                                        </v-select>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <template v-if="statsPartitionTagLoading && isAllowedToDashboard">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                    style="margin: 24px"
                                />
                            </template>
                            <template
                                v-else-if="
                                    !statsPartitionTagLoading &&
                                    !statsPartitionTag &&
                                    isAllowedToDashboard
                                "
                            >
                                Aucun tag utilisé
                            </template>
                            <pie-chart
                                v-else-if="statsPartitionTag && isAllowedToDashboard"
                                :data="statsPartitionTag"
                                :options="{
                                    plugins: {
                                        legend: {
                                            display: selectedPartitionTag ? true : false,
                                            position: 'bottom',
                                        },
                                    },
                                    maintainAspectRatio: false,
                                    ticks: { min: 0 },
                                }"
                                :height="$vuetify.display.mobile ? 200 : 300"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : '6'" v-if="statsSuppliers">
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        "
                    >
                        <v-card-title primary-title>
                            <span>Charges par fournisseur</span>
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <template v-if="statsSuppliersLoading">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                    style="margin: 24px"
                                />
                            </template>
                            <bar-chart
                                v-else-if="statsSuppliers"
                                :data="statsSuppliers"
                                :options="statsCustomersOptions"
                                :height="$vuetify.display.mobile ? 200 : 350"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" v-if="statsSocialChargesMonthly">
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        "
                    >
                        <v-card-title primary-title>
                            <span>Charges de personnel</span>
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <template v-if="statsSocialChargesMonthlyLoading">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                    style="margin: 24px"
                                />
                            </template>
                            <bar-chart
                                v-else-if="statsSocialChargesMonthly"
                                :data="statsSocialChargesMonthly"
                                :options="statsSocialChargesMonthlyOptions"
                                :height="$vuetify.display.mobile ? 200 : 350"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row no-gutters v-else-if="emit === 'profitAndLoss'">
                <v-col v-if="displayScenariosSelection && budgetId">
                    <BarChartCard
                        :title="$t('shared.profitAndLossForecastVersusActual')"
                        :legend="true"
                        :loading="forecastBudgetWithActualLoading"
                        :data="profitAndLossForecastVersusActualData"
                        :activeBack="false"
                        :selectedPeriod="selectedPeriod"
                        :md6="false"
                        :midHeight="true"
                        :showYearNMinus1="false"
                        :yearNMinus1="false"
                        :selectedTags="[]"
                    >
                    </BarChartCard>
                </v-col>
                <v-col v-if="!(displayScenariosSelection && budgetId)">
                    <BarChartCard
                        :title="$t('shared.profitAndLoss')"
                        :loading="
                            statsProfitAndLossDetail
                                ? statsProfitAndLossPartitionMonthlyLoading
                                : statsProfitAndLossMonthlyLoading
                        "
                        :data="
                            statsProfitAndLossDetail
                                ? statsProfitAndLossPartitionMonthlyData
                                : statsProfitAndLossMonthlyData
                        "
                        :activeBack="false"
                        :yearNMinus1="statsProfitAndLossYearNMinus1"
                        :showYearNMinus1="true"
                        @onYearNMinus1Changed="
                            (value) => {
                                statsProfitAndLossYearNMinus1 = value;
                            }
                        "
                        :md6="false"
                        :selectedTags="[]"
                    >
                    </BarChartCard>
                </v-col>
            </v-row>
            <v-row v-else-if="emit === 'tresorerie'">
                <v-col v-if="!displayCashFlowChart">
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        "
                    >
                        <v-card-title primary-title>
                            <v-row no-gutters>
                                <v-col
                                    :cols="$vuetify.display.mobile ? 12 : 6"
                                    class="ml-0 mt-0 mb-0 pt-0 pb-0"
                                >
                                    {{ $t("shared.cashBalance") }}
                                </v-col>
                                <v-col :cols="$vuetify.display.mobile ? 12 : 6">
                                    <v-select-filled
                                        v-model="cashBalance"
                                        :items="cashBalancesOutputs"
                                        :item-title="getBankAccountName"
                                        return-object
                                        v-if="cashBalancesOutputs.length > 1"
                                        class="mt-2 mb-0 pt-0 pb-0 mr-4"
                                        label="Compte bancaire"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <template v-if="cashBalanceLoading">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                    style="margin: 24px"
                                />
                            </template>
                            <template v-else-if="cashBalance">
                                <bar-chart
                                    v-if="cashBalance"
                                    :data="cashBalance"
                                    :options="cashBalanceOptions"
                                    :height="$vuetify.display.mobile ? 200 : 350"
                                    :key="cashBalance.bankAccount.id"
                                />
                            </template>
                            <template v-else-if="addBankAccountAvailable">
                                <p>
                                    Ajoutez un compte bancaire pour visualiser l'évolution du solde
                                    bancaire
                                </p>
                                <v-btn
                                    class="btn_card"
                                    @click="createBankAccount()"
                                    rounded
                                    elevation="0"
                                    size="small"
                                >
                                    Ajoutez un compte bancaire
                                </v-btn>
                            </template>
                            <template v-else>
                                <p>Pas de donnée pour cette période</p>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col v-if="displayCashFlowChart">
                    <v-card
                        :class="
                            $vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        "
                    >
                        <v-card-title primary-title>
                            {{ $t("shared.cashFlowPlan") }}
                        </v-card-title>
                        <v-card-text style="text-align: center" class="pa-0">
                            <CashFlowPlan
                                :companyId="companyId"
                                :inBudgetId="budgetId"
                                :startDate="startDate"
                                :endDate="endDate"
                                :selectedPeriod="selectedPeriod"
                                @periods-list-changed="onPeriodsListChanged"
                            >
                            </CashFlowPlan>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-else-if="emit?.id">
                <v-col cols="12">
                    <BarChartCard
                        :title="emit.name"
                        :data="this.emitDetailFormatedData"
                        :loading="emitDetailLoading"
                        :activeBack="false"
                        :yearNMinus1="yearMinus1EmitDisplayed"
                        :showYearNMinus1="true"
                        @onYearNMinus1Changed="
                            (value) => {
                                yearMinus1EmitDisplayed = value;
                            }
                        "
                        :md6="false"
                        :selectedTags="[]"
                    >
                    </BarChartCard>
                    <!-- <IndicatorDetailedBarChartCard
                        v-if="displayScenariosSelection && budgetId"
                        title="Détail"
                        :legend="true"
                        :loading="false"
                        :activeBack="false"
                        :selectedPeriod="selectedPeriod"
                        :md6="false"
                        :midHeight="true"
                        :showYearNMinus1="true"
                        :yearNMinus1="false"
                        :selectedTags="[]"
                    >
                    </IndicatorDetailedBarChartCard> -->
                </v-col>
            </v-row>
            <ChoosePersonalisedCard
                v-model="chooseAccountableKey"
                :companyId="companyId"
                @update_dashboardSettings="refresh()"
            />
        </template>
    </v-container>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
import gql from "graphql-tag";
import { User } from "../store/store";

import moment, { unitOfTime } from "moment-timezone";

import {
    Bar as BarChart,
    Doughnut as DoughnutChart,
    Line as LineChart,
    Pie as PieChart,
} from "vue-chartjs";

import BarChartCard from "./dashboard/BarChartCard.vue";
import BarChartCardPurchase from "./dashboard/BarChartCardPurchase.vue";
import BarChartCardSales from "./dashboard/BarChartCardSales.vue";
// import IndicatorDetailedBarChartCard from "./dashboard/IndicatorDetailedBarChartCard.vue";
import CardAmount from "./CardAmount.vue";
import CardBalance from "./CardBalance.vue";
import CardBank from "./CardBank.vue";
import CardRatio from "./CardRatio.vue";
import ChoosePersonalisedCard from "./ChoosePersonalisedCard.vue";
import CashFlowPlan from "./dashboard/CashFlowPlan.vue";
import ossWidgetEmbedder from "./ossComponents/ossWidgetEmbedder.vue";
import TutorialButtonDialog from "./tutorial/TutorialButtonDialog.vue";
// import Tutorial from "./Tutorial.vue"

// import DASHBOARD_SETTING from "../graphql/dashboard/DashboardSetting.gql";
import BUDGET_QUERY from "../graphql/budget/Budget.gql";
import SCENARIO_NAMES from "../graphql/budget/BudgetScenario.gql";
import Compute_Forecast_With_Actual from "../graphql/budget/ComputeForecastWithActual.gql";
import DASHBOARD_INDICATORS from "../graphql/computedIndicator/GetComputedIndicators.gql";
import EMIT_COMPUTED_TABLE from "../graphql/computedIndicator/GetIndicatorAmount.gql";
import EXTENSIONS_LIST from "../graphql/extension/ExtentionsContext.gql";
import PARTITION_TAG_QUERY from "../graphql/tag/CompanyPartitionTags.gql";

import { chartColors } from "../../../backend/src/common/chart/graphServices";
// import { getUserDisplayName } from "../services/userServices"

import { Apollo } from "@/decorators";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { checkAccessRights } from "../services/accessRightServices";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../services/dateServices";

import emitter from "@/services/emitter";
import { Offer_type } from "@/types/offer.types";
import { Component, Vue, Watch, toNative } from "vue-facing-decorator";

// import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices"

// import { PartitionTag } from "../../../types";

// import { connectBank } from "..servicesbankServices"

const BobbeeImg = require("../assets/img/bobbee3d/bobbee3dTuto.png");

@Component({
    components: {
        LineChart,
        PieChart,
        DoughnutChart,
        BarChart,
        BarChartCard,
        BarChartCardPurchase,
        BarChartCardSales,
        // IndicatorDetailedBarChartCard,
        CardAmount,
        CardRatio,
        CardBank,
        ChoosePersonalisedCard,
        CardBalance,
        CashFlowPlan,
        ossWidgetEmbedder,
        TutorialButtonDialog,
        // Tutorial
    },
})
export class Dashboard extends Vue {
    checkInvoiceOrSale411Display = false;

    checkInvoiceOrSale401Display = false;

    checkInvoiceOrSale421Display = false;

    checkInvoiceOrSale455Display = false;

    checkInvoiceOrSale4670Display = false;

    checkInvoiceOrSale4671Display = false;

    checkInvoiceOrSale511And531Display = false;

    displayCashFlowChart = true; // if false : display cashBalance chart, if true : display cashFlow chart

    yearMinus1EmitDisplayed = false;

    /**
     * Indicates if all balances are reconciled
     */
    areBalancesReconciled: boolean;

    get cashChartsDisplayOptions() {
        const options = [
            { id: true, name: "Plan de trésorerie" },
        ];

        if (this.areBalancesReconciled) {
            options.push({ id: false, name: "Solde de trésorerie" });
        } else {
            this.displayCashFlowChart = true;
        }

        return options;
    }

    // budget update parameters

    budgetId: string = "";
    selectedPeriod: number = 1;
    periodsList = [];
    skipScenariosQuery: boolean = true;
    skipBudgetForecastQuery: boolean = true;
    budget: any = null;
    _startDate: moment.Moment = null;
    _endDate: moment.Moment = null;
    forecastBudgetWithActualLoading: boolean = false;
    purchaseForecastVersusActualData: any = null;
    salesForecastVersusActualData: any = null;
    profitAndLossForecastVersusActualData: any = null;

    // newCommonFormatCurrency(
    //     value,
    //     undefined

    // ) {
    //     return newCommonFormatCurrency(value, undefined);
    // }
    // dateMenu: boolean = false

    get monthCount() {
        if (this.$vuetify.display.mobile) {
            return 11;
        }
        if (this.selectedAccountingPeriod) {
            return moment(this.selectedAccountingPeriod.end).diff(
                moment(this.selectedAccountingPeriod.start),
                "months",
            );
        }
        return 23;
    }

    get offerType() {
        return this.$store.state.offerType;
    }

    get isAllowedToDashboard() {
        // switch (this.offerType) {
        //     case Offer_type.ACCOUNTING_PREMIUM:
        //     case Offer_type.BUSINESS_BASIC:
        //     case Offer_type.BUSINESS_ESSENTIAL:
        //     case Offer_type.BUSINESS_PREMIUM:
        //     case Offer_type.TRAINING:
        //         return true;
        //     default:
        //         return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "business",
            "dashboard",
            true,
            "isAllowedToDashboard",
        );
    }

    // @Watch("start")
    // onStartDateChanged(date) {
    //     this.start = date;
    // }

    getBankAccountName(item) {
        if (item && item.bankAccount) {
            return item.bankAccount.name;
        }
        return "XXX";
    }

    get end() {
        if (this.start) {
            return moment(this.start)
                .add(this.monthCount, "months")
                .endOf("month")
                .format("YYYY-MM-DD");
        }
        return "";
    }

    // accountingPeriodDialog = false
    unitOfTime: unitOfTime.StartOf = "month";

    get unitOfTimes(): unitOfTime.DurationConstructor {
        return (this.unitOfTime + "s") as unitOfTime.DurationConstructor;
    }

    get format() {
        if (this.unitOfTime === "day") return "DD-MM-YY";
        if (this.unitOfTime === "week") return "DD-MM-YY";
        if (this.unitOfTime === "month") return "MM-YY";
        // debugger;
        return "DD-MM-YY";
    }

    currentPalette = "cool";

    selectedPartitionTag = "";

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "business", "dashboard");
        return authorized;
    }

    get enableBank() {
        return (
            this.currentUser.profile?.configuration?.bankTransaction?.read &&
            (!this.currentUser.companyUser || !this.currentUser.companyUser?.accessRights.length)
        );
    }

    get addBankAccountAvailable() {
        if (this.accounts) return false;
        if (!this.currentUser.profile?.configuration.bankAccount.write) return false;
        //
        if (!this.currentUser.company.accountingFirm) {
            return true;
        }
        if (this.currentUser.company.id === this.company.id) {
            return true;
        }
        return false;
    }

    get amountType() {
        if (this.company && isNotSubjectToVAT(this.company.vatSystem)) return "grossAmountSigned";
        return "netAmountSigned";
    }

    get amountTypeString() {
        if (this.company && isNotSubjectToVAT(this.company.vatSystem)) return "TTC";
        return "HT";
    }

    get dateTicksLabelCount() {
        const start = moment(this.start);
        const end = moment(this.end);
        return end.diff(start, this.unitOfTimes) + 1;
    }

    get dateTicksLabels() {
        let modulo = 2;
        if (this.$vuetify.display.mobile) {
            modulo = 3;
        } else if (this.unitOfTime === "day") {
            modulo = 50;
        } else if (this.unitOfTime === "week") {
            modulo = 8;
        }
        if (!this.start || !this.end) return [];

        const start = moment(this.start);
        const end = moment(this.end);

        const current = moment(start);
        const dates = {};
        for (let i = 0; i < this.dateTicksLabelCount; i++) {
            dates[i] = "";
        }
        for (let i = 0; i < this.dateTicksLabelCount; i += modulo) {
            dates[i] = current.startOf(this.unitOfTime).format(this.format);
            current.add(modulo, this.unitOfTimes);
        }
        if (this.dateRange[0] === -1) {
            this.dateRange[0] = 0;
        }
        if (this.dateRange[1] > this.dateTicksLabelCount || this.dateRange[1] <= 0) {
            let max = 0;
            if (this.monthCount > 12) {
                max = Math.round(this.dateTicksLabelCount / 2) - 1;
            } else {
                max = this.dateTicksLabelCount - 1;
            }
            this.dateRange[1] = max;
            if (this.dateRange[0] > this.dateRange[1]) {
                this.dateRange[0] = 0;
            }
        }
        console.log("dates", dates);
        return dates;
    }

    get startDates() {
        if (this.start) return this.getStartDates(this.unitOfTime, this.unitOfTimes);
        return [];
    }

    get endDates() {
        if (this.start) return this.getEndDates(this.unitOfTime, this.unitOfTimes);
        return [];
    }

    get startDate() {
        if (this.startDates.length) return this.startDates[this.dateRange[0]];
        return "";
    }

    get endDate() {
        if (this.endDates.length) return this.endDates[this.dateRange[1]];
        return "";
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    getStartDates(_unitOfTime, unitOfTimes) {
        const dates = [];
        if (this.start && this.end) {
            const start = moment(this.start);
            const end = moment(this.end);
            const count = end.diff(start, unitOfTimes) + 1;
            const current = moment(start);
            for (let i = 0; i < count; i++) {
                let startOf = current.startOf(_unitOfTime);
                if (!i && startOf.isBefore(start)) {
                    startOf = start;
                }
                dates.push(startOf.format("YYYY-MM-DD"));
                current.add(1, unitOfTimes);
            }
        }
        return dates;
    }

    getEndDates(_unitOfTime, unitOfTimes) {
        const dates = [];
        if (this.start && this.end) {
            const start = moment(this.start);
            const end = moment(this.end);
            const count = end.diff(start, unitOfTimes) + 1;
            const current = moment(start);
            for (let i = 0; i < count; i++) {
                let endOf = current.endOf(_unitOfTime);
                if (i === count - 1 && endOf.isAfter(end)) {
                    endOf = end;
                }
                dates.push(endOf.format("YYYY-MM-DD"));
                current.add(1, unitOfTimes);
            }
        }
        return dates;
    }

    get companyId() {
        return this.company?.id;
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get isIncomingOutgoingPayment() {
        if (
            this.company?.profile &&
            this.company.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get periods() {
        if (this.startDate && this.endDate) {
            return [
                {
                    start: this.startDate,
                    end: this.endDate,
                },
            ];
        }
        return [];
    }

    get monthlyPeriods() {
        const result = JSON.parse(JSON.stringify(this.periods));
        for (const p of result) {
            p.monthly = true;
        }
        return result;
    }

    emit = null;
    chooseAccountableKey = false; // true quand dialog ouvert

    isCardAmount(card) {
        const opDef = card.definition?.operator;
        if (opDef === "v1" || opDef === "-v1") {
            return true;
        }
        return false;
    }

    isCardRatio(card) {
        const opDef = card.definition?.operator;
        const formatedOpDef = opDef.replaceAll("-", "");
        if (formatedOpDef === "v1/v2") {
            return true;
        }
        return false;
    }

    onVueDetailedChanged(card) {
        this.emit = card.definition?.type ? card.definition.type : card;
    }

    @Apollo({
        query: DASHBOARD_INDICATORS,
        variables() {
            return {
                companyId: this.companyId,
                onlyMine: true,
                // operatorsWanted: undefined,
                range: this.limitationRange ? this.limitationRange : undefined,
            };
        },
        skip() {
            return !this.isAuthorized || !this.company;
        },
        specificResult({ data, loading }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data.getComputedIndicators?.computedIndicators) {
                    this.personalisedCards = JSON.parse(
                        JSON.stringify(data.getComputedIndicators.computedIndicators),
                    );
                } else {
                    this.personalisedCards = [];
                }
            }
        },
    })
    personalisedCards = []; // se remplit petit à petit des parametres des cards choisies

    @Apollo({
        query: EMIT_COMPUTED_TABLE,
        variables() {
            return {
                indicatorId: this.emit.id,
                companyId: this.companyId,
                periods: this.monthlyPeriods,
            };
        },
        skip() {
            return !this.isAuthorized || !this.company || !this.emit?.id;
        },
        specificResult({ data, loading }: any) {
            this.emitDetailLoading = loading;
            if (!loading && data) {
                if (data.getIndicatorAmount?.output) {
                    this.computedTable = data.getIndicatorAmount.output;
                } else {
                    this.computedTable = {};
                }
            }
        },
    })
    computedTable: any = {};

    emitDetailLoading: boolean = false;

    get emitDetailFormatedData() {
        this.emitDetailLoading = true;
        const result = { dataset: null, datasets: null, labels: [] };

        // --- ComputeLabels ---
        const start = moment(this.periods[0].start);
        const end = moment(this.periods[0].end);
        const monthCount = end.diff(start, "months") + 1;
        const current = moment(start);
        for (let i = 0; i < monthCount; i++) {
            let startOf = current.startOf("month");
            if (!i && startOf.isBefore(start)) {
                startOf = start;
            }
            result.labels.push(startOf.format("MM-YYYY"));
            current.add(1, "months");
        }

        const displaySign = this.computedTable?.tables?.[0]?.rows?.[0]?.displaySign
            ? this.computedTable.tables[0].rows[0].displaySign
            : 1;

        if (this.yearMinus1EmitDisplayed) {
            result.datasets = [
                { label: "N-1", data: [] },
                { label: "N", data: [] },
            ];
            if (this.computedTable?.tables?.[0]?.rows?.[0]?.monthlyAmounts?.netAmounts2?.length) {
                result.datasets[1].data =
                    this.computedTable.tables[0].rows[0].monthlyAmounts.netAmounts2[0];
                result.datasets[0].data =
                    this.computedTable.tables[0].rows[0].monthlyAmounts.netAmounts2[1];
                for (const set of result.datasets) {
                    set.data = set.data.map((d) => (d *= displaySign));
                }
            }
        } else {
            if (this.computedTable?.tables?.[0]?.rows?.[0]?.monthlyAmounts?.netAmounts) {
                //this.computedTable?.tables?.[0]?.rows?.[0]?.monthlyAmounts?.netAmounts2?.length
                result.dataset = this.computedTable.tables[0].rows[0].monthlyAmounts.netAmounts2[0]; //netAmounts2[0];
                result.dataset = result.dataset.map((d) => (d *= displaySign));
            }
        }

        this.emitDetailLoading = false;

        return result;
    }

    // get settingsPersonalisedCards() {
    //     // fait pour récupérer la liste des settings (sans les id) renvoyés par l'apollo
    //     const result = [];
    //     // result.push(
    //     //     { key1: "K5M7dlWgTNheYB5E_70", key2: "", options: null },
    //     //     { key1: "HjWAbLWSgQTi5Wei", key2: "", options: null },
    //     //     { key1: "GMmaP08MdztHyvBH", key2: "", options: null },
    //     // );
    //     for (const compteur in this.personalisedCards) {
    //         if (this.personalisedCards[compteur] && this.personalisedCards[compteur].setting) {
    //             result.push(this.personalisedCards[compteur].setting);
    //         }
    //     }
    //     return result;
    // }

    @State2Way("updateDashboardStart", "dashboard.start")
    start!: any;

    @State2Way("updateDashboardDateRange", "dashboard.dateRange")
    dateRange!: any;

    @State2Way("updateAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    beforeMount() {
        this.onAccountingPeriodChanged(this.selectedAccountingPeriod, undefined);
        emitter.$on("launchTuto", this.startTuto);
    }

    @Watch("selectedAccountingPeriod")
    onAccountingPeriodChanged(value, prevValue) {
        if (value) {
            if (!this.start) {
                this.start = moment(value.start).format();
            } else {
                const mBegin = moment(this.start);
                if (mBegin.isBefore(moment(value.start)) || mBegin.isAfter(moment(value.end))) {
                    this.start = moment(value.start).format();
                }
            }
        } else {
            if (!this.start) {
                this.start = moment().startOf("year").format();
            }
        }
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.personalisedCards) {
            this.$apollo.queries.personalisedCards.refetch();
        } else {
            debugger;
        }
    }

    @Apollo(
        {
            query: gql`
                query BankAccountsQuery($companyId: ID!) {
                    bankAccounts(where: { company: { id: $companyId } }) {
                        id
                    }
                }
            `,
            variables() {
                return {
                    companyId: this.companyId,
                };
            },
            skip() {
                return !this.enableBank || !this.isAuthorized || !this.companyId;
            },
        },
        (data) => (data && data.bankAccounts.length > 0 ? data.bankAccounts : null),
    )
    accounts = null;

    cashBalance: any = null;

    @Apollo(
        {
            query: gql`
                query (
                    $companyId: ID!
                    $startDate: DateTime
                    $endDate: DateTime
                    $unitOfTime: String
                ) {
                    statsCashBalanceDaily(
                        data: {
                            companyId: $companyId
                            startDate: $startDate
                            endDate: $endDate
                            unitOfTime: $unitOfTime
                        }
                    ) {
                        outputs
                    }
                }
            `,
            skip() {
                return (
                    !this.isAuthorized ||
                    !this.companyId ||
                    !this.startDate ||
                    !this.endDate ||
                    this.emit !== "tresorerie"
                );
            },
            variables() {
                return {
                    companyId: this.companyId,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    unitOfTime: this.unitOfTime,
                };
            },
            debounce: 500,
            specificResult({ data, loading, networkStatus }: any) {
                this.cashBalanceLoading = loading;
                if (!loading) {
                    if (data && data.statsCashBalanceDaily && data.statsCashBalanceDaily.outputs) {
                        const cashBalancesOutputs = [];
                        for (const output of data.statsCashBalanceDaily.outputs) {
                            const datasets = [
                                {
                                    label: this.$t("shared.cashBalance"),
                                    data: JSON.parse(JSON.stringify(output.dataset)),
                                    // steppedLine: "middle"
                                },
                            ];
                            chartColors("bar", datasets, this.currentPalette);
                            const cashBalance = {
                                bankAccount: output.bankAccount,
                                labels: output.labels,
                                datasets,
                                result: output.result,
                            };
                            cashBalancesOutputs.push(cashBalance);
                        }
                        this.cashBalancesOutputs = cashBalancesOutputs;
                        if (this.cashBalancesOutputs.length) {
                            this.cashBalance = this.cashBalancesOutputs[0];
                        } else {
                            this.cashBalance = null;
                        }
                    } else {
                        this.cashBalance = null;
                        this.cashBalancesOutputs = [];
                    }
                }
                return null;
            },
        },
        // data => (data && data.statsCashBalanceDaily ? data.statsCashBalanceDaily : null)
    )
    cashBalancesOutputs = [];

    cashBalanceLoading: boolean = false;

    get cashBalanceOptions() {
        const self = this;
        // const options = ref<ChartOptions<'bar'>>({
        const options = {
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        afterLabel: function (tooltipItem: any): string | string[] {
                            // var label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (
                                self.cashBalance.result &&
                                tooltipItem.dataIndex >= 0 &&
                                tooltipItem.dataIndex < self.cashBalance.result.length
                            ) {
                                const balance = self.cashBalance.result[tooltipItem.dataIndex];
                                const rows = [];
                                const incomes = [];
                                const expenses = [];
                                let totalKnownIncomes = 0;
                                let totalKnownExpenses = 0;

                                if (balance.details && balance.details.length) {
                                    balance.details.forEach((detail) => {
                                        // rows.push(detail.tagName + ": " + detail.amount + " €");

                                        if (detail.amount < 0) {
                                            totalKnownExpenses += detail.amount;
                                            expenses.push(detail);
                                        } else {
                                            totalKnownIncomes += detail.amount;
                                            incomes.push(detail);
                                        }
                                    });
                                }

                                let row = "";
                                if (!balance.incomes) {
                                    row = "REVENUS : 0 €";
                                    rows.push(row);
                                } else {
                                    if (Math.abs(balance.incomes - totalKnownIncomes) > 0.1) {
                                        row = "REVENUS";
                                        rows.push(row);
                                        row = "  - Non classés: ";
                                        row +=
                                            Math.round(
                                                (balance.incomes - totalKnownIncomes) * 100,
                                            ) / 100;
                                        row += " €";
                                        rows.push(row);
                                    }
                                    incomes.forEach((detail) => {
                                        rows.push(
                                            "  - " + detail.tagName + ": " + detail.amount + " €",
                                        );
                                    });
                                }

                                if (!balance.expenses) {
                                    row = "DEPENSES : 0 €";
                                    rows.push(row);
                                } else {
                                    if (Math.abs(balance.expenses - totalKnownExpenses) > 0.1) {
                                        row = "DEPENSES";
                                        rows.push(row);
                                        row = "  - Non classées: ";
                                        row +=
                                            Math.round(
                                                (balance.expenses - totalKnownExpenses) * 100,
                                            ) / 100;
                                        row += " €";
                                        rows.push(row);
                                    }
                                    expenses.forEach((detail) => {
                                        rows.push(
                                            "  - " + detail.tagName + ": " + detail.amount + " €",
                                        );
                                    });
                                }
                                return rows;
                            }
                            return "";
                        },
                    },
                },
            },
        };
        return options;
    }

    @Apollo({
        query: gql`
            query (
                $companyId: ID!
                $partitionTagId: ID
                $aaFilter: String
                $startDate: DateTime
                $endDate: DateTime
                $amountType: String
            ) {
                statsPartitionTag(
                    data: {
                        companyId: $companyId
                        partitionTagId: $partitionTagId
                        aaFilter: $aaFilter
                        startDate: $startDate
                        endDate: $endDate
                        amountType: $amountType
                    }
                ) {
                    labels
                    dataset
                }
            }
        `,
        skip() {
            return (
                !this.isAuthorized ||
                (this.emit !== "costs" && this.emit !== "sales") ||
                !this.companyId ||
                !this.startDate ||
                !this.endDate
            );
        },
        variables() {
            return {
                aaFilter: this.emit === "costs" ? "6" : "70",
                companyId: this.companyId,
                partitionTagId: this.selectedPartitionTag ? this.selectedPartitionTag : "",
                startDate: this.startDate,
                endDate: this.endDate,
                amountType: this.amountType,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            this.statsPartitionTagLoading = loading;
            if (!loading) {
                if (
                    data &&
                    data.statsPartitionTag &&
                    data.statsPartitionTag.dataset &&
                    data.statsPartitionTag.dataset.length
                ) {
                    this.dbStatsPartitionTag = data.statsPartitionTag;
                } else {
                    this.dbStatsPartitionTag = null;
                }
            }
        },
    })
    dbStatsPartitionTag: any = null;

    // statsPartitionTag: any = null;
    statsPartitionTagLoading: boolean = false;
    // startStatsPartitionTagLabel = ""

    root = {
        name: "Racine",
        tags: [],
        selected: null,
    };

    get selectedPath() {
        let path = [this.root];
        let current = this.root;
        while (current.selected?.tags.length) {
            path.push(current.selected);
            current = current.selected;
        }
        return path;
    }

    removeSelectedPath(index) {
        const toModify = [];
        for (let i = this.selectedPath.length - 1; i >= 0; i--) {
            toModify.push(this.selectedPath[i]);
        }
        for (const current of toModify) {
            current.selected = null;
        }
    }

    get startStatsPartitionTagLabel() {
        let startPath = "";

        let current = this.root;
        while (current.selected) {
            if (startPath) {
                startPath += "/";
            }
            startPath += current.selected.name;
            current = current.selected;
        }
        // let startPaths = []
        // if (current.selected.length) {
        //     for (const selectedTag of current.selected) {
        //         let startPath1 = ""
        //         if (startPath) {
        //             startPath1 += startPath + "/"
        //         }
        //         startPath1 += selectedTag.name
        //         startPaths.push(startPath1)
        //     }
        // } else if (startPath) {
        //     // startPath += "/"
        //     startPaths.push(startPath)
        // }

        return startPath;
    }

    removeEmptyTag(currentTag) {
        for (let index = currentTag.tags.length - 1; index >= 0; index--) {
            const tag = currentTag.tags[index];
            if (!tag.tags.length) {
                currentTag.tags.splice(index, 1);
                continue;
            }
            this.removeEmptyTag(tag);
        }
    }

    @Watch("selectedPartitionTag")
    onPartitionTagIdchanged() {
        this.root = {
            name: "Racine",
            tags: [],
            selected: null,
        };
        const partition = this.partitionTags.find((p) => p.id === this.selectedPartitionTag);
        if (partition) {
            for (const tag of partition.tags) {
                const subTagNames = tag.name.split("/");
                let current = this.root;
                for (const subTagName of subTagNames) {
                    const lcSubTagName = subTagName.toLowerCase();
                    let subTag = current.tags.find((t) => t.name.toLowerCase() === lcSubTagName);
                    if (subTag) {
                        current = subTag;
                    } else {
                        subTag = {
                            name: subTagName,
                            tags: [],
                            selected: null,
                        };
                        current.tags.push(subTag);
                    }
                    current = subTag;
                }
            }
        }
        this.removeEmptyTag(this.root);
    }

    get statsPartitionTag() {
        let statsPartitionTag = null;
        if (this.dbStatsPartitionTag?.dataset?.length) {
            const labels = [];
            const data = [];
            for (let index = 0; index < this.dbStatsPartitionTag.labels.length; index++) {
                let label = this.dbStatsPartitionTag.labels[index];
                if (this.startStatsPartitionTagLabel) {
                    if (label.startsWith(this.startStatsPartitionTagLabel)) {
                        label = label.substring(this.startStatsPartitionTagLabel.length + 1);
                    } else {
                        continue;
                    }
                }
                const pos = label.indexOf("/");
                if (pos !== -1) {
                    label = label.substring(0, pos);
                }
                let labelIndex = labels.indexOf(label);
                if (labelIndex === -1) {
                    labels.push(label);
                    data.push(this.dbStatsPartitionTag.dataset[index]);
                } else {
                    data[labelIndex] += this.dbStatsPartitionTag.dataset[index];
                }
            }

            const datasets = [
                {
                    data,
                },
            ];
            chartColors("pie", datasets[0], this.currentPalette);
            statsPartitionTag = {
                labels: labels,
                datasets: datasets,
            };
        }
        return statsPartitionTag;
    }

    //
    // Profit And Loss Monthly
    //
    @Apollo(
        {
            query: gql`
                query (
                    $companyId: ID!
                    $startDate: DateTime
                    $endDate: DateTime
                    $unitOfTime: String
                    $yearNMinus1: Boolean
                ) {
                    statsProfitAndLossMonthly(
                        data: {
                            companyId: $companyId
                            startDate: $startDate
                            endDate: $endDate
                            unitOfTime: $unitOfTime
                            yearNMinus1: $yearNMinus1
                        }
                    ) {
                        labels
                        dataset
                        datasets
                    }
                }
            `,
            skip() {
                return (
                    !this.isAuthorized ||
                    this.emit !== "profitAndLoss" ||
                    this.statsProfitAndLossDetail ||
                    !this.companyId ||
                    !this.selectedPartitionTag ||
                    !this.startDate ||
                    !this.endDate
                );
            },
            variables() {
                return {
                    companyId: this.companyId,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    unitOfTime: this.unitOfTime,
                    yearNMinus1: this.statsProfitAndLossYearNMinus1,
                };
            },
            debounce: 500,
            specificResult({ data, loading, networkStatus }: any) {
                this.statsProfitAndLossMonthlyLoading = loading;
                debugger;
                if (!loading) {
                    if (
                        data &&
                        data.statsProfitAndLossMonthly &&
                        data.statsProfitAndLossMonthly.labels &&
                        data.statsProfitAndLossMonthly.labels.length
                    ) {
                        this.statsProfitAndLossMonthlyData = data.statsProfitAndLossMonthly;
                    } else {
                        this.statsProfitAndLossMonthlyData = null;
                    }
                } else {
                    this.statsProfitAndLossMonthlyData = null;
                }
            },
        },
        // data => ((data && data.statsProfitAndLossMonthly && data.statsProfitAndLossMonthly.datasets && data.statsProfitAndLossMonthly.datasets.length) ? data.statsProfitAndLossMonthly : null)
    )
    statsProfitAndLossMonthlyData: any = null;

    statsProfitAndLossYearNMinus1: boolean = false;

    statsProfitAndLossDetail: boolean = false;

    statsProfitAndLossMonthlyLoading: boolean = false;

    //
    // Profit And Loss Partition Monthly
    //
    @Apollo({
        query: gql`
            query ($companyId: ID!, $startDate: DateTime, $endDate: DateTime, $unitOfTime: String) {
                statsProfitAndLossPartitionMonthly(
                    data: {
                        companyId: $companyId
                        startDate: $startDate
                        endDate: $endDate
                        unitOfTime: $unitOfTime
                    }
                ) {
                    labels
                    datasets
                }
            }
        `,
        skip() {
            return (
                !this.isAuthorized ||
                this.emit !== "profitAndLoss" ||
                !this.statsProfitAndLossDetail ||
                !this.companyId ||
                !this.selectedPartitionTag ||
                !this.startDate ||
                !this.endDate
            );
        },
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.startDate,
                endDate: this.endDate,
                unitOfTime: this.unitOfTime,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            this.statsProfitAndLossPartitionMonthlyLoading = loading;
            if (!loading) {
                if (
                    data &&
                    data.statsProfitAndLossPartitionMonthly &&
                    data.statsProfitAndLossPartitionMonthly.labels &&
                    data.statsProfitAndLossPartitionMonthly.labels.length
                ) {
                    this.statsProfitAndLossPartitionMonthlyData =
                        data.statsProfitAndLossPartitionMonthly;
                } else {
                    this.statsProfitAndLossPartitionMonthlyData = null;
                }
            }
        },
    })
    statsProfitAndLossPartitionMonthlyData: any = null;

    statsProfitAndLossPartitionMonthlyLoading: boolean = false;

    //
    // Social Charge Monthly
    //
    @Apollo(
        {
            query: gql`
                query (
                    $companyId: ID!
                    $startDate: DateTime
                    $endDate: DateTime
                    $unitOfTime: String
                ) {
                    statsSocialChargesMonthly(
                        data: {
                            companyId: $companyId
                            startDate: $startDate
                            endDate: $endDate
                            unitOfTime: $unitOfTime
                        }
                    ) {
                        labels
                        datasets
                    }
                }
            `,
            skip() {
                return (
                    !this.isAuthorized ||
                    this.emit !== "costs" ||
                    !this.companyId ||
                    !this.selectedPartitionTag ||
                    !this.startDate ||
                    !this.endDate
                );
            },
            variables() {
                return {
                    companyId: this.companyId,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    unitOfTime: this.unitOfTime,
                };
            },
            debounce: 500,
            specificResult({ data, loading, networkStatus }: any) {
                this.statsSocialChargesMonthlyLoading = loading;
                if (!loading) {
                    if (
                        data &&
                        data.statsSocialChargesMonthly &&
                        data.statsSocialChargesMonthly.datasets &&
                        data.statsSocialChargesMonthly.datasets.length
                    ) {
                        // hack to avoid cpu loop
                        // if (data.statsSocialChargesMonthly.datasets &&
                        //     data.statsSocialChargesMonthly.datasets.length &&
                        //     data.statsSocialChargesMonthly.datasets[0].backgroundColor) {
                        //     debugger;
                        //     return;
                        // }
                        const datasets = JSON.parse(
                            JSON.stringify(data.statsSocialChargesMonthly.datasets),
                        );
                        chartColors("bar", datasets, data.currentPalette);
                        this.statsSocialChargesMonthly = {
                            labels: data.statsSocialChargesMonthly.labels,
                            datasets: datasets,
                        };
                    } else {
                        this.statsSocialChargesMonthly = null;
                    }
                }
                return null;
            },
        },
        // data => ((data && data.statsSocialChargesMonthly && data.statsSocialChargesMonthly.datasets && data.statsSocialChargesMonthly.datasets.length) ? data.statsSocialChargesMonthly : null)
    )
    statsSocialChargesMonthly: any = null;

    statsSocialChargesMonthlyLoading: boolean = false;

    get statsSocialChargesMonthlyOptions() {
        return {
            plugins: {
                legend: { display: !this.$vuetify.display.mobile, position: "bottom" },
            },
            scales: {
                y: {
                    beginAtZero: true,
                },
                x: {
                    beginAtZero: true,
                },
            },
            maintainAspectRatio: false,
        };
    }

    //
    // Customers
    //

    statsCustomersLoading: boolean = false;

    @Apollo({
        query: gql`
            query ($companyId: ID!, $startDate: DateTime, $endDate: DateTime) {
                statsCustomers(
                    data: { companyId: $companyId, startDate: $startDate, endDate: $endDate }
                ) {
                    labels
                    dataset
                }
            }
        `,
        skip() {
            return (
                !this.isAuthorized ||
                !this.companyId ||
                !this.startDate ||
                !this.endDate ||
                this.emit !== "sales"
            );
        },
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.startDate,
                endDate: this.endDate,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            this.statsCustomersLoading = loading;
            if (
                data &&
                data.statsCustomers &&
                data.statsCustomers.dataset &&
                data.statsCustomers.dataset.length
            ) {
                // debugger;
                const datasets = [
                    {
                        // label: this.$t('shared.cashBalance'),
                        data: JSON.parse(JSON.stringify(data.statsCustomers.dataset)),
                    },
                ];

                chartColors("bar", datasets, data.currentPalette);
                this.statsCustomers = {
                    labels: data.statsCustomers.labels,
                    datasets,
                };
                // this.statsCustomers = {
                //     labels: labels,
                //     datasets: datasets
                // };
            } else {
                this.statsCustomers = null;
            }
        },
    })
    statsCustomers: any = null;

    get statsCustomersOptions() {
        return {
            plugins: {
                legend: { display: false },
                tooltip: {
                    mode: "point",
                },
            },
            scales: {
                y: {
                    beginAtZero: true,
                    grid: {
                        color: "rgba(0, 0, 0, 0)",
                    },
                },
                x: {
                    beginAtZero: true,
                },
            },
            maintainAspectRatio: false,
            indexAxis: "y",
        };
    }

    //
    // Products
    //
    statsProductsLoading: boolean = false;

    @Apollo({
        query: gql`
            query ($companyId: ID!, $startDate: DateTime, $endDate: DateTime) {
                statsProducts(
                    data: { companyId: $companyId, startDate: $startDate, endDate: $endDate }
                ) {
                    labels
                    dataset
                }
            }
        `,
        skip() {
            return !this.isAuthorized || !this.companyId || !this.startDate || !this.endDate;
        },
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.startDate,
                endDate: this.endDate,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            this.statsProductsLoading = loading;
            if (
                data &&
                data.statsProducts &&
                data.statsProducts.dataset &&
                data.statsProducts.dataset.length
            ) {
                // debugger;
                const datasets = [
                    {
                        // label: this.$t('shared.cashBalance'),
                        data: JSON.parse(JSON.stringify(data.statsProducts.dataset)),
                    },
                ];

                chartColors("bar", datasets, data.currentPalette);
                this.statsProducts = {
                    labels: data.statsProducts.labels,
                    datasets,
                };
                // this.statsProducts = {
                //     labels: labels,
                //     datasets: datasets
                // };
            } else {
                this.statsProducts = null;
            }
        },
    })
    statsProducts: any = null;

    //
    // Suppliers
    //

    statsSuppliersLoading: boolean = false;

    @Apollo({
        query: gql`
            query ($companyId: ID!, $startDate: DateTime, $endDate: DateTime) {
                statsSuppliers(
                    data: { companyId: $companyId, startDate: $startDate, endDate: $endDate }
                ) {
                    labels
                    dataset
                }
            }
        `,
        skip() {
            return (
                !this.isAuthorized ||
                this.emit !== "costs" ||
                !this.companyId ||
                !this.startDate ||
                !this.endDate
            );
        },
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.startDate,
                endDate: this.endDate,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            this.statsSuppliersLoading = loading;
            if (
                data &&
                data.statsSuppliers &&
                data.statsSuppliers.dataset &&
                data.statsSuppliers.dataset.length
            ) {
                // debugger;
                const datasets = [
                    {
                        // label: this.$t('shared.cashBalance'),
                        data: JSON.parse(JSON.stringify(data.statsSuppliers.dataset)),
                    },
                ];

                chartColors("bar", datasets, data.currentPalette);
                this.statsSuppliers = {
                    labels: data.statsSuppliers.labels,
                    datasets,
                };
                // this.statsSuppliers = {
                //     labels: labels,
                //     datasets: datasets
                // };
            } else {
                this.statsSuppliers = null;
            }
        },
    })
    statsSuppliers: any = null;

    get headers() {
        return [
            { text: this.$t("shared.operation"), value: "operation" },
            { text: this.$t("shared.date"), value: "date" },
            { text: this.$t("shared.amount"), value: "amount" },
        ];
    }

    getRandomInt() {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    }

    getRandomColor() {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    @Watch("unitOfTime")
    onUnitOfTimeChanged(value, prevValue) {
        if (prevValue && value !== prevValue) {
            const pervUnitOfTimes: unitOfTime.DurationConstructor = (prevValue +
                "s") as unitOfTime.DurationConstructor;
            const prevStartDates = this.getStartDates(prevValue, pervUnitOfTimes);
            const prevEndDates = this.getEndDates(prevValue, pervUnitOfTimes);

            const prevStartDate = prevStartDates[this.dateRange[0]];
            const prevEndDate = prevEndDates[this.dateRange[1]];

            const start = moment(this.start);
            const unitOfTimes: unitOfTime.DurationConstructor = (value +
                "s") as unitOfTime.DurationConstructor;
            this.dateRange.splice(0, 1, moment(prevStartDate).diff(start, unitOfTimes));
            this.dateRange.splice(1, 1, moment(prevEndDate).diff(start, unitOfTimes));
        }
    }

    createBankAccount() {
        this.$router.push({
            name: "companyEditionTab",
            params: {
                activeTab: "Bank",
                companyId: this.companyId,
            },
        });
    }

    @Apollo({
        query: SCENARIO_NAMES,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.isAuthorized || this.skipScenariosQuery;
        },
        specificResult({ data, loading, networkStatus }: any) {
            // debugger
            this.loading = loading;
            if (!loading && data.budgets) {
                this.scenarios = data.budgets;
                this.scenarios.unshift({ id: "", name: "Pas de budget" });
                this.budgetId = "";
                this.skipScenariosQuery = true;
                // this.budgetToEdit = "";
                // this.budgetToCopy = "";
                // console.log(this.scenarios);
            }
        },
    })
    scenarios: Array<any> = [];

    get displayScenariosSelection() {
        let display = false;
        if (
            this.emit === "sales" ||
            this.emit === "costs" ||
            this.emit === "profitAndLoss" ||
            (this.emit === "tresorerie" && this.displayCashFlowChart)
        ) {
            display = true;
            this.skipScenariosQuery = false;
        } else {
            this.skipScenariosQuery = true;
        }
        return display;
    }

    onPeriodsListChanged(data) {
        this.periodsList = data;
    }

    @Apollo({
        query: Compute_Forecast_With_Actual,
        variables() {
            return {
                budgetId: this.budgetId,
                startDate: getDBFormattedStartDate(this._startDate),
                endDate: getDBFormattedEndDate(this._endDate),
            };
        },
        skip() {
            return !this.isAuthorized || !this.budgetId || this.skipBudgetForecastQuery;
        },
        specificResult({ data, loading, networkStatus }: any) {
            debugger;
            this.forecastBudgetWithActualLoading = loading;
            if (!loading) {
                if (
                    data &&
                    data.computeForecastWithActual &&
                    data.computeForecastWithActual.result
                ) {
                    this.forecastBudgetWithActualData = data.computeForecastWithActual.result;
                    this.purchaseForecastVersusActualData = {
                        labels: this.forecastBudgetWithActualData.budgetData.labels,
                        datasets: [
                            {
                                label: "Prévisionnelles",
                                data: this.forecastBudgetWithActualData.budgetData.purchases,
                            },
                            {
                                label: "Réelles",
                                data: this.forecastBudgetWithActualData.actualData.purchases,
                            },
                        ],
                        study: this.forecastBudgetWithActualData.study,
                    };
                    this.salesForecastVersusActualData = {
                        labels: this.forecastBudgetWithActualData.budgetData.labels,
                        datasets: [
                            {
                                label: "Prévisionnelles",
                                data: this.forecastBudgetWithActualData.budgetData.sales,
                            },
                            {
                                label: "Réelles",
                                data: this.forecastBudgetWithActualData.actualData.sales,
                            },
                        ],
                        study: this.forecastBudgetWithActualData.study,
                    };

                    this.profitAndLossForecastVersusActualData = {
                        labels: this.forecastBudgetWithActualData.budgetData.labels,
                        datasets: [
                            {
                                label: "Prévisionnelles",
                                data: JSON.parse(
                                    JSON.stringify(
                                        this.forecastBudgetWithActualData.budgetData.sales,
                                    ),
                                ),
                            },
                            {
                                label: "Réelles",
                                data: JSON.parse(
                                    JSON.stringify(
                                        this.forecastBudgetWithActualData.actualData.sales,
                                    ),
                                ),
                            },
                        ],
                        study: this.forecastBudgetWithActualData.study,
                    };
                    for (
                        let i = 0;
                        i < this.forecastBudgetWithActualData.budgetData.purchases.length;
                        i++
                    ) {
                        this.profitAndLossForecastVersusActualData.datasets[0].data[i] +=
                            this.forecastBudgetWithActualData.budgetData.purchases[i];
                    }
                    for (
                        let i = 0;
                        i < this.forecastBudgetWithActualData.actualData.purchases.length;
                        i++
                    ) {
                        this.profitAndLossForecastVersusActualData.datasets[1].data[i] +=
                            this.forecastBudgetWithActualData.actualData.purchases[i];
                    }
                    this.skipBudgetForecastQuery = true;
                } else {
                    this.forecastBudgetWithActualData = null;
                    this.purchaseForecastVersusActualData = null;
                    this.salesForecastVersusActualData = null;
                    this.profitAndLossForecastVersusActualData = null;
                }
            }
        },
    })
    forecastBudgetWithActualData: any = null;

    async computePeriodsList() {
        if (this.budgetId) {
            const resultB = await this.$apollo.query({
                query: BUDGET_QUERY,
                variables: {
                    id: this.budgetId,
                },
            });
            if (resultB.data && resultB.data.budget) {
                this.budget = resultB.data.budget;
            }
            if (this.budget.parameters) {
                const periods = [];
                const firstLine = { id: 1, name: "1er exercice" };
                periods.unshift(firstLine);
                for (
                    let periodIndex = 2;
                    periodIndex <= this.budget.parameters.periodsNumber;
                    periodIndex++
                ) {
                    const newLine = { id: periodIndex, name: periodIndex + "e exercice" };
                    periods.push(newLine);
                }
                this.periodsList = periods;
            } else if (this.budget.form.study && this.budget.form.study.periodsNumber) {
                const periods = [];
                const firstLine = { id: 1, name: "1er exercice" };
                periods.unshift(firstLine);
                for (
                    let periodIndex = 2;
                    periodIndex <= this.budget.form.study.periodsNumber;
                    periodIndex++
                ) {
                    const newLine = { id: periodIndex, name: periodIndex + "e exercice" };
                    periods.push(newLine);
                }
                this.periodsList = periods;
            }
        }
    }

    selectPeriodFromBudget() {
        // return start and end parameters to pass to datasets.slice
        // if this computation is to heavy we can store an array with computed indexes and just find the correct return value in this array when selectedPeriod change
        let startValue = moment(this.budget.date);
        const firstMonthCount = this.budget.parameters
            ? this.budget.parameters.firstPeriodMonthsNumber - 1
            : this.budget.form.study.firstPeriodMonthsNumber - 1;
        const periodsNumber = this.budget.parameters
            ? this.budget.parameters.periodsNumber
            : this.budget.form.study.periodsNumber;
        let endValue = moment(this.budget.date).add(firstMonthCount, "months");
        if (firstMonthCount && this.selectedPeriod > 1) {
            startValue = endValue.clone().add(1, "months");
            endValue = endValue.add(12, "months");
            if (this.selectedPeriod > 2) {
                startValue = endValue.clone().add(1, "months");
                endValue = endValue.add(12, "months");
                if (this.selectedPeriod > 2) {
                    startValue = endValue.clone().add(1, "months");
                    endValue = endValue.add(12, "months");
                    if (this.selectedPeriod > 3) {
                        startValue = endValue.clone().add(1, "months");
                        endValue = endValue.add(12, "months");
                        if (this.selectedPeriod > 4) {
                            startValue = endValue.clone().add(1, "months");
                            endValue = endValue.add(12, "months");
                        }
                    }
                }
            }

            const monthCount = firstMonthCount + periodsNumber * 12 - 1;
            const budgetEndDate = moment(this.budget.date).add(monthCount, "months");
            if (startValue.isAfter(budgetEndDate)) {
                startValue = budgetEndDate.clone().add(-11, "months");
                endValue = budgetEndDate.clone();
            }
            if (endValue.isAfter(budgetEndDate)) {
                endValue = budgetEndDate.clone();
                startValue = budgetEndDate.clone().add(-11, "months");
            }
            this._startDate = startValue;
            this._endDate = endValue;
        }
    }

    async queryBudgetForecastFromBudget() {
        await this.computePeriodsList();
        this.selectPeriodFromBudget();
        this.skipBudgetForecastQuery = false;
    }

    queryBudgetForecastFromPeriods() {
        this.selectPeriodFromBudget();
        this.skipBudgetForecastQuery = false;
    }

    @Apollo({
        query() {
            return PARTITION_TAG_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        debounce: 500,
        skip() {
            return !this.isAuthorized || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.partitionTags = data.partitionTags;
                if (this.partitionTags.length) {
                    this.selectedPartitionTag = this.partitionTags[0].id;
                }
            } else {
                this.partitionTags = [];
            }
        },
    })
    partitionTags = [];

    @Apollo({
        query() {
            return EXTENSIONS_LIST;
        },
        variables() {
            return {
                type: "CARD",
                displayIn: "DASHBOARD",
            };
        },
        debounce: 500,
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.extensionsCard = data.getExtensions.map((ext) => ({
                    ...ext,
                    dialogStatus: false,
                }));
            }
        },
    })
    extensionsCard = [];

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("total"),
                title: "Tuto page de démarrage",
                pages: [
                    {
                        text: "L’écran d’accueil du tableau de bord vous propose divers indicateurs visuels alimentés en temps réel par la comptabilité.",
                        img: BobbeeImg,
                        outed: true,
                        position: "top",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Date"),
                title: "Tuto page de démarrage",
                pages: [
                    {
                        text: "Vous avez la possibilité de vous positionner dans le temps et de border les dates qui vous interessent. La mise à jour des données se fait instantanément.",
                        position: "bottom",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("TreasuryDashboard"),
                title: "Tuto page de démarrage",
                pages: [
                    {
                        text: "Ce nombre représente le solde de l'application",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("TurnoverDashboard"),
                title: "Tuto page de démarrage",
                pages: [
                    {
                        text: "Ce nombre représente le chiffre d'affaires de l'application",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("fillersDashboard"),
                title: "Tuto page de démarrage",
                pages: [
                    {
                        text: "Ce nombre représente les charges de l'application",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("AddIndicatorDashboard"),
                title: "Tuto page de démarrage",
                pages: [
                    {
                        text: "Vous pouvez personnaliser votre tableau de bord en ajoutant un indicateur (ratio personnalisé ou données)",
                        position: "left",
                        align: "center",
                    },
                ],
            },
        ]);
    }

    onDisplayCashFlowChartChanged() {
        if (this.displayCashFlowChart) {
            this.unitOfTime = "month";
        }
    }
}

export default toNative(Dashboard);
</script>
